import { JSConn } from "@/utilities/js-conn";
import { map as Rmap } from "ramda";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import { format, formatDistance } from "date-fns";
import TipTapDisplay from "@/components/TipTapDisplay/TipTapDisplay.vue";
import { ordinalize } from "@/utilities/ordinalize";
import { itemRouteBuilder, NamedRts } from "@/router";

import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";

export default defineComponent({
  name: "workOrderPrint",
  props: {
    workOrderId: {
      type: String,
      required: true,
    },
  },
  components: {
    LoadingAnimation,
    TipTapDisplay,
  },

  setup(props, ctx) {
    let $store = ctx.root.$store;

    const dataLoaded = ref(false);
    const loadingMessage = ref("Loading Work Order...");

    const showRouteBuilder = () => {
      return itemRouteBuilder(NamedRts.workOrderTasks, props.workOrderId);
    };

    const billingDashboardRouteBuilder = () => {
      return {
        name: NamedRts.billingDashboard,
      };
    };

    const loadWorkOrder = () => {
      const jsConnWorkOrder = new JSConn();
      const jsConnLineItems = new JSConn();
      const jsConnLotUnits = new JSConn();

      jsConnWorkOrder.formParams = {
        id: props.workOrderId,
      };

      const dataPromises = [
        $store.dispatch("needWorkOrder", jsConnWorkOrder),
        $store.dispatch("needLotUnits", jsConnLotUnits),
        $store.dispatch("needLineItems", jsConnLineItems),
      ];

      return Promise.all(dataPromises);
    };

    onMounted(() => {
      loadWorkOrder().then(() => {
        dataLoaded.value = true;
      });
    });

    const workOrder = computed(() => {
      return $store.getters.workOrder;
    });

    const isFieldWorker = computed(() => {
      return $store.getters.isFieldWorker;
    });

    const workOrderNotes = computed(() => {
      const apiNotes = $store.getters.workOrderNotes;
      const rightNow = new Date();
      return Rmap(nt => {
        const createdAt = new Date(nt.created_at);
        const humanizedDate = format(createdAt, "MMMM d, yyyy, h:mm a");
        const time_ago_in_words = formatDistance(rightNow, createdAt) + " ago";
        return {
          ...nt,
          humanized_created_at: humanizedDate,
          time_ago_in_words: time_ago_in_words,
        };
      }, apiNotes);
    });

    const workOrderInstructions = computed(() => {
      return $store.getters.workOrderInstructions;
    });

    return {
      dataLoaded,
      loadingMessage,

      workOrder,
      isFieldWorker,
      workOrderNotes,
      workOrderInstructions,
      ordinalize,
      showRouteBuilder,
      billingDashboardRouteBuilder,
    };
  },
});
